import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BreadcrumbService } from './breadcrumb.service';

@Injectable()

/**
 * InvoiceResolver adds support for automatically adding translations for data that is resolved for a route
 */
export abstract class BreadcrumbResolver<T> implements Resolve<T>
{
	/**
	 * BreadcrumbResolver constructor
	 *
	 * @param {BreadcrumbService} breadcrumbService
	 */
	constructor(private breadcrumbService: BreadcrumbService)
	{
	}

	/**
	 * Resolves route data
	 *
	 * @param {ActivatedRouteSnapshot} route
	 * @returns {Observable<T>}
	 */
	resolve(route: ActivatedRouteSnapshot): Observable<T>
	{
		return this.getData(route.params).map(
			data => {
				if (route.data.hasOwnProperty('breadcrumb')) {
					this.breadcrumbService.addBreadcrumbTranslation(route.data.breadcrumb, this.getBreadcrumb(data));
				}

				return data;
			}
		);
	}

	/**
	 * Returns the Observable for the resolved data
	 *
	 * @param params
	 * @returns {Observable<T>}
	 */
	abstract getData(params): Observable<T>

	/**
	 * Returns the breadcrumb label
	 *
	 * @param {T} data
	 * @returns {string}
	 */
	abstract getBreadcrumb(data: T): string
}



// WEBPACK FOOTER //
// ./src/app/breadcrumb/breadcrumb.resolver.ts